import { useQuery, UseQueryOptions } from 'react-query';
import { httpClient } from 'src/utils/HttpClients';
import type { TProfile } from 'src/types';
import get from 'lodash/get';
import { useAuth } from 'src/utils/auth';

export const useGetUserDetails = (
    id: string,
    options: Partial<UseQueryOptions<TProfile | null, unknown, TProfile | null, string[]>> | void
) => {
    const { user } = useAuth();

    const queryFn = async () => {
        const roles = get(user, 'profile.user.roles', []);

        if (
            (Array.isArray(roles) && roles.includes('ROLE_ELMO_SUPER')) ||
            (typeof roles === 'string' && roles === 'ROLE_ELMO_SUPER')
        ) {
            return Promise.resolve(null);
        }

        const response = await httpClient.get<TProfile>('/profile');
        return get(response, 'data', null) as TProfile | null;
    };

    return useQuery(['user', id], queryFn, {
        keepPreviousData: true,
        refetchOnMount: false,
        ...options,
    });
};
